import { NgStyle } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { TrackingModelService } from '@frontend/promo-homewidget';
import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import { WebAnalyticModel } from '../../../../../common/web-tracking/web-analytic.model';
import { EdsContent } from '../../eds-models/eds-content';
import { EdsDetails } from '../../eds-models/eds-details';
import { PlayerReward } from '../../eds-models/player-reward';
import { getEdsDetails } from '../../store/eds.selectors';
import { PartiallyRewardedResultTileComponent } from '../partially-rewarded-result-tile/partially-rewarded-result-tile.component';

@Component({
    selector: 'multi-rewards-list',
    templateUrl: './multi-rewards-list.component.html',
    styleUrls: ['./multi-rewards-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgStyle, DynamicHtmlDirective, PartiallyRewardedResultTileComponent, DsCard],
})
export class MultiRewardsListComponent implements OnInit, OnDestroy {
    toggle: boolean = false;
    webAnalytic: WebAnalyticModel = new WebAnalyticModel();
    selectedEvent: string;
    edsContent: EdsContent;
    private readonly destroy$ = new Subject<void>();
    dsComponents: DSComponents;

    constructor(
        private store: Store<{ edsModuleData: EdsDetails }>,
        private trackingModelService: TrackingModelService,
        private designSystemHelperService: DesignSystemHelperService,
    ) {}

    ngOnInit(): void {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
        this.bindRewardsListDetails();
    }

    bindRewardsListDetails() {
        this.store
            .select(getEdsDetails)
            .pipe(takeUntil(this.destroy$))
            .subscribe((edsDetails: EdsDetails) => {
                this.edsContent = edsDetails?.edsContent;
                this.selectedEvent = '';
            });
    }
    eventsToggle(id: string, title: string, eventIndex: number): void {
        if (this.selectedEvent && this.selectedEvent !== id) {
            this.collapseEvents(this.selectedEvent);
        }
        this.selectedEvent = this.selectedEvent === id ? '' : id;
        this.collapseEvents(id);
        this.webTrackingForToggle(title, eventIndex);
    }

    collapseEvents(eventId: string) {
        const tncClassList: any = document.getElementById(eventId + '__header')?.classList;
        const tncDescription: any = document.getElementById(eventId + '__body')?.classList;
        tncClassList.toggle('theme-down');
        tncClassList.toggle('theme-up');
        tncDescription.toggle('collapsible-visible');
    }

    webTrackingForToggle(title: string, eventIndex: number) {
        this.toggle = !this.toggle;
        const action = this.toggle ? 'Expand' : 'Collapse';
        this.trackingModelService.submitTracking({
            CategoryEvent: 'promo hub',
            LabelEvent: 'player activity promotions eds',
            ActionEvent: 'click',
            PositionEvent: title + '-' + eventIndex,
            LocationEvent: 'reward list',
            EventDetails: action,
            URLClicked: 'not applicable',
        });
    }

    loadPendingPrizeData(): PlayerReward {
        const rewardData = new PlayerReward();
        rewardData.resultPrize = this.edsContent?.pendingPrize;
        return rewardData;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
